import { gql } from "@apollo/client";

export const MY_COMMERCIAL_QUERY = gql`
    query MyCommercialData($timePeriod: TimePeriod $highlightsTimePeriod: TimePeriod $filters: SalesFilterInput $commercialFilters: SalesFilterInput) {
        rankInMarket (filter: $filters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        marketShare (filter: $filters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        kpiReportedDollarSold (filter: $commercialFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        salesGrowthRateDollarsSold (filter: $commercialFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        allCommodityVolume (filter: $commercialFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        averagePricePerUnit (filter: $commercialFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        percentageDollarsSoldOnPromotion (filter: $commercialFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        percentageDollarsSoldOnDisplay (filter: $commercialFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }
        innovationRate (filter: $commercialFilters) {
            items {
                cmcYvsCMLY
                cMvsGoal
                cMvsLM
                cqcYvsCQLY
                cQvsGoal
                cQvsLQ
                currentMonth
                currentQuarter
                currentYear
                cYvsGoal
                cYvsLY
                goalCurrentMonth
                goalCurrentQuarter
                goalCurrentYear
                lastMonth
                lastQuarter
                lastYear
                sameMonthLastYear
                sameQuarterLastYear
            }
        }



        reportedDollarSoldBySubBrand(timePeriod: $highlightsTimePeriod, filter: $commercialFilters) {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }
        distributorByReportedSales(timePeriod: $highlightsTimePeriod, filter: $commercialFilters) {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }
        retailerByReportedSales(timePeriod: $highlightsTimePeriod, filter: $commercialFilters) {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }



        profitabilitySoldByByBrand(timePeriod: $highlightsTimePeriod, filter: $commercialFilters) {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }
        brandMarketShareByDollarSold (filter: $filters) {
            items {
                brandName
                currentYear
                dollarSoldCurrentMonth
                dollarSoldCurrentQuarter
                dollarSoldLastMonth
                dollarSoldLastQuarter
                lastYear
                percentage
            }
        }
        reportedDollarSoldByRegionBySubBrand(filter: $filters) {
            items {
                region
                values {
                    salesAmount
                    subBrandName
                }
            }
        }
        reportedDollarSoldByRegion(timePeriod: $timePeriod, filter: $filters) {
            items {
                lastPeriodNetSales
                name
                netSales
                percentage
                rank
                unitSold
            }
        }
        reportedDollarSoldByState(timePeriod: $timePeriod, filter: $filters) {
           items {
            mtdValue
            qtdValue
            stateName
            ytdValue
            }
        }
        reportedDollarsSoldMonthlyBySubBrand(filter: $filters){
            items {
                month
                    values {
                reportedSalesAmount
                subBrandName
                    }
                }
        }
        reportedDollarSalesByBrandWithCompetitor{
            items {
            brandName
            currentMonth
            currentQuarter
            currentYear
            lastMonth
            lastQuarter
            lastYear
            }
        }
        top10SKUsByReportedDollarsSold (filter: $filters) {
            items {
                currentMTD
                currentQTD
                currentYTD
                lastMTD
                lastQTD
                lastYTD
                sku
            }
        }
        bottom10SKUsByReportedDollarsSold (filter: $filters) {
            items {
                currentMTD
                currentQTD
                currentYTD
                lastMTD
                lastQTD
                lastYTD
                sku
            }
        }
        basePriceVsPromotedPrice (filter: $filters) {
            items {
                avgPromoPriceMTDCurrent
                avgPromoPriceMTDLast
                avgPromoPriceQTDCurrent
                avgPromoPriceQTDLast
                avgPromoPriceYTDCurrent
                avgPromoPriceYTDLast
                basePriceMTDCurrent
                basePriceMTDLast
                basePriceQTDCurrent
                basePriceQTDLast
                basePriceYTDCurrent
                basePriceYTDLast
                brandName
                categoryName
                channelName
                companyName
                routeToMarketName
                subBrandName
            }
        }
        
        





       
    }

`;